import {
  BurstModeOutlined,
  CategoryOutlined,
  DashboardOutlined,
  FormatQuoteOutlined,
  InboxOutlined,
  ListAltOutlined,
  LocalOfferOutlined,
  PeopleAltOutlined,
  ShoppingCartOutlined,
  StarBorderOutlined,
} from "@material-ui/icons";
// SummarizeTwoToneIcon
import React from "react";
// import CategoryIcon from "@material-ui/icons/Category";
import Dashboard from "./App/Main/Dashboard";
// import Merchants from "./App/Main/Merchants";
// import Items from "./App/Main/Items";
import UserList from "./App/Main/UserList";
// import Invoice from "./App/Main/Invoice";
// import CurrencyExchangeIcon from '/CurrencyExchange';
import Subcategory from "./App/Main/Subcategory";
import Category from "./App/Main/Category";
import Testimonials from "./App/Main/Testimonials";
import Products from "./App/Main/Product";
import Orders from "./App/Main/Orders";
import WebEnquiries from "./App/Main/WebEnquiry";
import LeadsList from "./App/Main/LeadsList";
import BestSellingProducts from "./App/Main/BestSellingProduct";
import Banners from "./App/Main/Banners";
// const x = false;
// const routes = {
//   Dashboard: [
//     {
//       title: "Dashboard",
//       path: "/dashboard",
//       component: Dashboard,
//       icon: <DashboardOutlined />,
//       exact: true,
//       // pathId: "61d48beb4e865687542a4d6e",
//       // role:"superadmin",
//     },
//   ],

//   User: [
//     {
//       title: "User List",
//       path: "/userList",
//       component: UserList,
//       icon: <GroupAddOutlined />,
//       exact: true,
//       pathId: "61d48beb4e865687542a4d6f",
//       // role:"superadmin",
//     },
//   ],

//   RulesOf_Game: [
//     {
//       title: "Testimonials",
//       path: "/testimonial",
//       component: Testimonials,
//       icon: <SportsEsportsOutlined />,
//       exact: true,
//       pathId: "61d48beb4e865687542a4d74",
//     },
//   ],
// };

export const routes = [
  {
    title: "Dashboard",
    path: "/dashboard",
    component: Dashboard,
    icon: <DashboardOutlined />,
    exact: true,
    // pathId: "61d48beb4e865687542a4d6e",
    // role:"superadmin",
  },
  {
    title: "Contact Details",
    path: "/enquiries",
    component: WebEnquiries,
    icon: <InboxOutlined />,
    exact: true,
    // pathId: "61d48beb4e865687542a4d6e",
    // role:"superadmin",
  },
  {
    title: "Leads list",
    path: "/leads",
    component: LeadsList,
    icon: <ListAltOutlined />,
    exact: true,
  },
  {
    title: "Banners",
    path: "/banners",
    component: Banners,
    icon: <BurstModeOutlined />,
    exact: true,
    // pathId: "61d48beb4e865687542a4d6e",
    // role:"superadmin",
  },
  {
    title: "Category",
    path: "/category",
    component: Category,
    icon: <CategoryOutlined />,
    exact: true,
  },
  
  {
    title: "Products",
    path: "/products",
    component: Products,
    icon: <LocalOfferOutlined />,
    exact: true,
  },
  {
    title: "User List",
    path: "/userList",
    component: UserList,
    icon: <PeopleAltOutlined />,
    exact: true,
    // pathId: "61d48beb4e865687542a4d6f"
    // role:"superadmin",
  },
  {
    title: "Orders",
    path: "/orders",
    component: Orders,
    icon: <ShoppingCartOutlined />,
    exact: true,
    // pathId: "61d48beb4e865687542a4d6f"
    // role:"superadmin",
  },
  {
    title: "Best Selling Products",
    path: "/best_selling_products",
    component: BestSellingProducts,
    icon: <StarBorderOutlined />,
    exact: true,
    // pathId: "61d48beb4e865687542a4d6f"
    // role:"superadmin",
  },
  {
    title: "Testimonials",
    path: "/testimonial",
    component: Testimonials,
    icon: <FormatQuoteOutlined />,
    exact: true,
    // pathId: "61d48beb4e865687542a4d6f"
    // role:"superadmin",
  },
];

// export const LoginRoutes = [
//   {
//     title: "Forgot Password",
//     path: "/forgot",
//     component: ForgotPassword,
//     icon: DashboardOutlined,
//     exact: true,
//   },
//   {
//     title: "Forgot Password",
//     path: "/change",
//     component: ChangePassword,
//     icon: DashboardOutlined,
//     exact: true,
//   },

// ]

// import AboutUs from "./AboutUs";
// import Categories from "./App/Main/Categories";
// import Contacts from "./App/Main/Contacts";
// import Services from "./App/Main/Services";
// import Users from "./App/Main/Users";
// import VariantOptions from "./App/Main/VariantOptions";

export default routes;
